import { GetAccessTokenFunc, LogoutFunc } from 'lib/hooks/useAuth'
import { Self } from 'lib/util/self'
import { createContext } from 'react'

export default createContext<{ self: Self, login: ()=> void, logout: LogoutFunc, getAccessToken: GetAccessTokenFunc }>(
  null
)
